import { loginFailure, loginStart, loginSuccess } from "./userRedux";
import axios from "axios";
import { message } from "antd";
import config from "../config";
import { setAccessToken } from "../requestMethods";

export const login = async (dispatch, user, navigate) => {
  const DOMAIN = config.REACT_APP_SERVER_DOMAIN;

  dispatch(loginStart());
  try {
    const res = await axios.post(`${DOMAIN}/api/auth/login`, user, { withCredentials: true });

    // ✅ ÉTAPE CRITIQUE : mettre le token en cache mémoire SYNCHRONOUSMENT
    // AVANT dispatch + navigate. Sinon, fetchMenu() partira avant que
    // redux-persist ait écrit dans localStorage → 401 → déconnexion.
    setAccessToken(res.data?.accessToken);

    dispatch(loginSuccess(res.data));

    if (res.data.success) {
      message.success("Connectez-vous avec succès");
      const role = res.data?.role;
      navigate(role === 'Securité' ? '/securite/dashboard' : '/');
    } else {
      throw new Error(res.data.message);
    }

  } catch (err) {
    dispatch(loginFailure());
    // Relance toujours une erreur avec le message du backend si disponible
    throw new Error(err.response?.data?.message || 'Une erreur est survenue. Veuillez réessayer.');
  }
};


export const register = async (dispatch, user) => {
  const DOMAIN = config.REACT_APP_SERVER_DOMAIN;

  dispatch(loginStart());
  try {
    const res = await axios.post(`${DOMAIN}/api/auth/register`, user);
    setAccessToken(res.data?.accessToken);
    dispatch(loginSuccess(res.data));
    if (res.data.success) {
      message.success("Les informations sont enregistrées avec succès");
    } else {
      message.error(res.data.message);
    }
  } catch (err) {
    dispatch(loginFailure());
    console.log(err);
    message.error("Quelque chose s'est mal passé");
  }
};


